// extracted by mini-css-extract-plugin
export default {"fixed-footer":"fixed-footer--6e99c3","fixedFooter":"fixed-footer--6e99c3"};